module.exports = __webpack_public_path__ + "images/embed/rolodex_tab_selected.png";